import {Injectable} from '@angular/core';
import 'rxjs/add/observable/of';
import {BaseService} from './base.service';
import {Observable} from 'rxjs/Observable';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class UserService extends BaseService {

  public getForms(): Observable<any> {
    return this.http.get(this.baseUrl + '/api/v2/admin/user/form', {headers: this.getHeader()});
  }

  public getUserData(idUser: number = null): Observable<any> {
    if (idUser !== null) {
      return this.http.get(this.baseUrl + '/api/v2/admin/asap-user/' + idUser, {headers: this.getHeader()});
    }
    return this.http.get(this.baseUrl + '/api/v2/admin/asap-user', {headers: this.getHeader()});
  }

  public getUserForm(): Observable<any> {
    return this.http.get(this.baseUrl + '/api/v2/admin/user/form' , {headers: this.getHeader()});
  }

  public getAdressByCep(cep: string): Observable<any> {
    const headerOptions = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    return this.http.get('http://viacep.com.br/ws/' + cep + '/json/', {headers: new HttpHeaders(headerOptions)});
  }

  public remove(id): Observable<any> {
    const url = this.baseUrl + '/api/v2/admin/user/delete/' + id;
    return this.http.delete(url, {headers: this.getHeader()});
  }

  public saveData(data: any, idCliente = null): Observable<any> {
    const headerOptions = {
      'Authorization': sessionStorage.getItem('token'),
      'Accept': 'application/json'
    };
    if (idCliente === null) {
      return this.http.post(this.baseUrl + '/api/v2/admin/asap-user/store',
        data,
        {headers: new HttpHeaders(headerOptions)});
    }
    return this.http.put(this.baseUrl + '/api/v2/admin/asap-user/' + idCliente + '/update',
      data,
      {headers: new HttpHeaders(headerOptions)});
  }


}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts